<template>
  <div :class="$style['order-message-content-all']">
    <div :class="$style['order-message-content']">
      <div :class="$style['order-message']">
        <div :class="$style['order-message-basic']">
          <table>
            <tr>
              <td ref="td">订单号：</td>
              <td>
                <div :class="$style['courier-number']">{{order_detail.orderNumber}}<pt-copy-button type="text" :copyContent="order_detail.orderNumber"
                                  text="[复制]"></pt-copy-button>
                </div>
              </td>
            </tr>
            <tr v-if="order_detail.business_source">
              <td ref="td">订单来源：</td>
              <td>{{order_detail.business_source}}</td>
            </tr>
            <tr>
              <td ref="td">商品ID：</td>
              <td>{{goodsData.goodsId}}</td>
            </tr>
            <tr>
              <td>商品名称：</td>
              <td>{{goodsData.name}}</td>
            </tr>
            <tr>
              <td>商品规格：</td>
              <td>
                <div :class="$style['goods-specifications']">
                  {{specifications.name?specifications.name:emptyText}}
                </div>
              </td>
            </tr>
            <tr>
              <td>商品数量：</td>
              <td>
                <div :class="$style['goods-specifications']">
                  {{placementDetails.goods&&placementDetails.goods.number}}
                </div>
              </td>
            </tr>
            <tr>
              <td>商品类型：</td>
              <td>{{order_detail.goods_type}}</td>
            </tr>
            <tr v-if="placementDetails.resampleOrder">
              <td>是否是重采订单：</td>
              <td>{{placementDetails.resampleOrder?'是':'否'}}</td>
            </tr>
            <tr v-if="goodsData.goodsCompanyName">
              <td>商品所属公司：</td>
              <td>{{goodsData.goodsCompanyName}}</td>
            </tr>
            <tr v-if="order_detail.organizationName">
              <td>订单所属公司：</td>
              <td>{{order_detail.organizationName}}</td>
            </tr>
            <tr v-if="order_detail.sharingPerson">
              <td>分享人：</td>
              <td>
                <template v-if="order_detail.sharingPerson.firstName">
                  <router-link v-if="user_url" :class="$style['get-customer-detail']"
                               :to="`/all-customer/customer-detail/${order_detail.sharingPerson.id}?state=basic-message`">
                    {{order_detail.sharingPerson.firstName}}
                  </router-link>
                  <template v-else>{{order_detail.sharingPerson.firstName}}</template>
                </template>
                <template v-else>{{emptyText}}</template>
              </td>
            </tr>
            <tr v-if="showWaitingForAmount">
              <td>待付款金额：</td>
              <td>{{waitingAmount}}</td>
            </tr>
            <tr>
              <td>付款方式：</td>
              <td>{{order_detail.paymentMode}}</td>
            </tr>
            <tr v-for="(item,index) in order_detail.paymentModeSummary" :key="index">
              <td>{{item.name}}：</td>
              <td>{{item.amount_show}}</td>
            </tr>
            <template v-if="isShowPaymentMessage">
              <tr v-for="(item,index) in paymentSummaryItems" :key="'item'+index">
                <td>{{item.name}}：</td>
                <td>{{item.amount_show}}<template v-if="item.information">（{{item.information}}）</template></td>
              </tr>
              <tr>
                <td>实付款：</td>
                <td>{{order_detail.payment_total?'¥'+order_detail.payment_total:'¥0'}}</td>
              </tr>
              <tr v-if="isRenewDeposit">
                <td>发送抽奖通知：</td>
                <td>{{order_detail.renewDepositNoLuckDrawNotice?'是':'否'}}</td>
              </tr>
              <tr>
                <td>收款方：</td>
                <td>{{order_detail.paymentAccount}}</td>
              </tr>
              <tr v-if="isThirdGoods">
                <td>收款账户：</td>
                <td>{{order_detail.payment_account}}</td>
              </tr>
              <tr>
                <td>下单时间：</td>
                <td>{{order_detail.created_date}}</td>
              </tr>
            </template>
            <template>
              <tr>
                <td>医院名称：</td>
                <td>{{(order_detail.extendInfo&&order_detail.extendInfo.hospitalName)?order_detail.extendInfo.hospitalName:'--'}}</td>
              </tr>
              <tr>
                <td>医院编号：</td>
                <td>{{(order_detail.extendInfo&&order_detail.extendInfo.hospitalCode)?order_detail.extendInfo.hospitalCode:"--"}}</td>
              </tr>
              <tr>
                <td>业务员姓名：</td>
                <td>{{(order_detail.salesMan&&order_detail.salesMan.name)?order_detail.salesMan.name:"--"}}</td>
              </tr>
              <tr>
                <td>业务员工号：</td>
                <td>{{(order_detail.salesMan&&order_detail.salesMan.workNumber)?order_detail.salesMan.workNumber:"--"}}</td>
              </tr>
            </template>
          </table>
        </div>
        <div>
          <table>
            <!-- <tr>
                            <td>代理商：</td>
                            <td></td>
                        </tr> -->
            <tr>
              <td>用户：</td>

              <td>{{order_detail.mallUserNickName}}</td>
            </tr>
            <template>
              <tr>
                <td>姓名：</td>
                <td>
                  <template v-if="placeUserRoleInformation.fullName">
                    <router-link v-if="user_url" :class="$style['get-customer-detail']"
                                 :to="`/all-customer/customer-detail/${placeUserRoleInformation.id}?state=basic-message`">
                      {{placeUserRoleInformation.fullName}}</router-link>
                    <template v-else>{{placeUserRoleInformation.fullName}}</template>
                  </template>
                  <template v-else>{{emptyText}}</template>
                </td>
              </tr>
              <template v-if="order_detail.type==='CONTRACT'">
                <tr>
                  <td>身份证号码：</td>
                  <td>{{order_detail.patient&&order_detail.patient.identityCard}}</td>
                </tr>
                <tr>
                  <td>CPS合同号：</td>
                  <td>{{order_detail.contractNumber}}</td>
                </tr>
              </template>
            </template>
            <tr>
              <td>联系方式：</td>
              <td>{{placeUserRoleInformation.mobile?placeUserRoleInformation.mobile:emptyText}}</td>
            </tr>
            <tr v-if="isShowReportReceiverMail">
              <td>报告接收邮箱：</td>
              <td>{{placementDetails.email?placementDetails.email:emptyText}}</td>
            </tr>
            <tr>
              <td>是否需要开票：</td>
              <td>{{(order_detail.placementDetails && order_detail.placementDetails.needInvoice)?'是':'否'}}</td>
            </tr>
						<tr>
							<td>是否续存：</td>
							<td>{{ order_detail.extendInfo&&order_detail.extendInfo.renewFlg==='Y'?'是':'否'  }}</td>
						</tr>
            <template v-if="needInvoice">
              <tr>
                <td>发票类型：</td>
                <td>{{invoice.invoice_type}}</td>
              </tr>
              <tr v-if="invoice.invoiceType==='ELECTRIC'">
                <td>发票接收邮箱：</td>
                <td>{{invoice.email}}</td>
              </tr>
              <template v-else>
                <tr>
                  <td>发票邮寄地址：</td>
                  <td>
                    <span :class="$style['shipping-address-name']">{{invoice.contacts}}</span>
                    <span :class="$style['shipping-address-name']">{{shippingAddress.phone}}</span>
                    {{(invoice.provinceName?invoice.provinceName:'')+(invoice.cityName?invoice.cityName:'')+
                                (invoice.districtName?invoice.districtName:'')+(invoice.postAddress?invoice.postAddress:'')}}
                  </td>
                </tr>
              </template>
              <template>
                <tr>
                  <td>发票抬头类型：</td>
                  <td>{{invoice.title_type}}</td>
                </tr>
                <tr v-if="invoice.titleType==='PERSONAL'">
                  <td>个人名称：</td>
                  <td>{{invoice.name}}</td>
                </tr>
                <template v-else>
                  <tr>
                    <td>公司名称：</td>
                    <td>{{invoice.name}}</td>
                  </tr>
                  <tr>
                    <td>纳税人识别号：</td>
                    <td>{{invoice.taxNumber}}</td>
                  </tr>
                </template>
              </template>
            </template>
            <!-- <tr>
                            <td><div style="color:white">ddd</div> </td>
                        </tr>
                        <tr>
                            <td><div style="color:white">ddd</div> </td>
                        </tr> -->
            <!-- <template v-if="order_detail.orderStatus=='SHIPPED' || order_detail.orderStatus=='RECEIVED'"> -->

            <!-- </template> -->
          </table>
        </div>
      </div>
      <div :class="$style['payment-message-content']" v-if="isShowPaymentMessage">
        <!-- <table>
                    <tr>
                        <td :style="{width:tdMaxWidth+'px'}"><div>支付方式：</div></td>
                        <td>{{order_detail.channelName}}</td>
                    </tr>
                </table> -->
        <div class="payment-message-content-item"><label :style="{width:tdMaxWidth+'px'}" :width="tdMaxWidth+'px'">
            {{isDepositAndBalance&&order_detail.channelName?'订金':""}}支付方式：</label>{{order_detail.channelName||emptyText}}</div>
        <div class="payment-message-content-item">
          <label>{{isDepositAndBalance&&order_detail.paymentTime?'订金':""}}支付时间：</label>{{order_detail.paymentTime||emptyText}}</div>
        <div class="payment-message-content-item">
          <label>{{isDepositAndBalance&&paymentDetails.payNumber?'订金':""}}支付流水号：</label>
          <div :class="$style['courier-number']">
            {{paymentDetails.payNumber||emptyText}}
            <pt-copy-button type="text" :copyContent="paymentDetails.payNumber" text="[复制]"></pt-copy-button>
          </div>
        </div>
      </div>

      <div :class="$style['payment-message-content']" v-if="isShowBalancePaymentMessage">
        <div class="payment-message-content-item"><label :style="{width:tdMaxWidth+'px'}"
                 :width="tdMaxWidth+'px'">尾款支付方式：</label>{{order_detail.balanceChannelName||emptyText}}</div>
        <div class="payment-message-content-item"><label>尾款支付时间：</label>{{order_detail.balancePaymentTime||emptyText}}</div>
        <div class="payment-message-content-item">
          <label>尾款支付流水号：</label>
          <div :class="$style['courier-number']">
            {{balancePaymentDetails.payNumber||emptyText}}
            <pt-copy-button type="text" :copyContent="balancePaymentDetails.payNumber" text="[复制]"></pt-copy-button>
          </div>
        </div>
      </div>
    </div>
    <div :class="$style['order-message']" class="shiping-message-content">
      <table>
        <tr>
          <td :style="{width:tdMaxWidth+'px'}">状态：</td>
          <td class="goods-order-status">{{order_detail.order_status}}
            <div @click="showShipingMessage">
              <i class="el-icon-caret-top" v-if="isShowShingMessage"></i>
              <i class="el-icon-caret-bottom" v-else></i>
            </div>
          </td>
          <template v-if="isShowShingMessage">
            <td>
              <div>发货形式：</div>
            </td>
            <td> {{order_detail.shippingMode}}
            </td>
          </template>
        </tr>
        <template v-if="isShowShingMessage">
          <tr>
            <td>发货时间：</td>
            <td>{{order_detail.shipingTime?order_detail.shipingTime:emptyText}}</td>
          </tr>
          <tr v-for="(item,index) in samples" :key="index">
            <td>样本条码号：</td>
            <td>{{item.sampleId}}</td>
            <td>
              <div>类型：</div>
            </td>
            <td>{{item.sample_type}}</td>
          </tr>
          <tr>
            <td>收件地址：</td>
            <td>
              <span :class="$style['shipping-address-name']">{{shippingAddress.contactName}}</span>
              <span :class="$style['shipping-address-name']">{{shippingAddress.phone}}</span>
              {{(shippingAddress.provinceName?shippingAddress.provinceName:'')+(shippingAddress.cityName?shippingAddress.cityName:'')+
                        (shippingAddress.districtName?shippingAddress.districtName:'')+(shippingAddress.postAddress?shippingAddress.postAddress:'')}}
            </td>
          </tr>
          <tr>
            <td>收件人：</td>
            <td>{{shippingAddress.contactName||'--'}}</td>
          </tr>
          <tr>
            <td>地址备注：</td>
            <td>{{shippingAddress.remarks||'--'}}</td>
          </tr>
          <tr>
            <td>快递公司：</td>
            <td>{{(order_detail.expressDetails&&order_detail.expressDetails.courierName)?order_detail.expressDetails.courierName:emptyText}}</td>
          </tr>
          <tr>
            <td>快递单号：</td>
            <td>
              <div :class="$style['courier-number']" v-if="order_detail.expressDetails">
                {{order_detail.expressDetails.courierNumber}}
                <pt-copy-button type="text" :copyContent="order_detail.expressDetails.courierNumber" text="[复制]"></pt-copy-button>
              </div>
              <template v-else>{{emptyText}}</template>
            </td>
          </tr>
          <tr v-if="isShowShingMark">
            <td>发货备注：</td>
            <td>{{(order_detail.expressDetails.remark)?order_detail.expressDetails.remark:emptyText}}</td>
          </tr>
        </template>
      </table>
    </div>
  </div>
</template>
<script>
import { hasPermissions } from 'utils/permissions'
const PERM_USER_MANAGEMENT = 'PERM_USER_MANAGEMENT'
const PERM_USER_READ_ONLY = 'PERM_USER_READ_ONLY'
export default {
  props: {
    orderDetail: {
      type: Object,
      default: function () {
        return {}
      }
    },
    goodsData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    specifications: {
      type: Object,
      default: function () {
        return {}
      }
    },
    paymentDetails: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isRenewDeposit: Boolean
  },
  data () {
    return {
      order_detail: this.orderDetail,
      isShowShingMessage: true,
      tdMaxWidth: '' // 订单详情表格第一列td的最大宽度
    }
  },
  watch: {
    orderDetail: {
      handler: function (val) {
        this.order_detail = val
      },
      deep: true
    }
  },
  computed: {
    shippingAddress () {
      return this.order_detail.shippingAddress || {}
    },
    // 支付金额相关信息
    paymentSummaryItems () {
      return (this.order_detail.paymentSummary && this.order_detail.paymentSummary.items) || []
    },
    // 订单商品是否是第三方商品
    isThirdGoods () {
      return this.order_detail.goods && this.order_detail.goods[0] && this.order_detail.goods[0].goodsBelong && this.order_detail.goods[0].goodsBelong === 'THIRD_PARTY'
    },

    // 样本
    samples () {
      return (this.order_detail.expressDetails && this.order_detail.expressDetails.samples) || []
    },
    // 用户信息
    placeUserRoleInformation () {
      return this.order_detail.placeUserRoleInformation || {}
    },
    // 是否显示支付信息
    isShowPaymentMessage () {
      return this.order_detail.orderStatus !== 'WAITING_FOR_PAYMENT' || this.order_detail.isBalanceWaitingPayment
    },
    // 订单是否是订金尾款支付
    isDepositAndBalance () {
      return this.placementDetails.paymentMode === 'DEPOSIT_AND_BALANCE'
    },
    // 该项信息为空的时候，显示的内容
    emptyText () {
      return '- -'
    },
    // 是否显示报告接收邮箱
    isShowReportReceiverMail () {
      return this.order_detail.goods && this.order_detail.goods[0] && this.order_detail.goods[0].type && this.order_detail.goods[0].type === 'GENE_THIRD'
    },
    // 是否显示发货备注
    isShowShingMark () {
      return this.order_detail.expressDetails
    },
    placementDetails () {
      return this.order_detail.placementDetails || {}
    },
    invoice () {
      return (this.order_detail.placementDetails && this.order_detail.placementDetails.invoice) || {}
    },
    needInvoice () {
      return this.order_detail.placementDetails && this.order_detail.placementDetails.needInvoice
    },
    // 是否显示待付款金额
    showWaitingForAmount () {
      return this.order_detail.orderStatus === 'WAITING_FOR_PAYMENT'
    },
    // 订单订金
    depositAmount () {
      let amount = null
      this.order_detail.paymentModeSummary.forEach(item => {
        if (item.name === '订金') {
          amount = item.amount_show + '（订金）'
        }
      })
      return amount
    },
    // 订单尾款
    balanceAmount () {
      let amount = null
      this.order_detail.paymentModeSummary.forEach(item => {
        if (item.name === '尾款') {
          amount = item.amount_show + '（尾款）'
        }
      })
      return amount
    },
    // 待支付金额显示数据
    waitingAmount () {
      return this.placementDetails.paymentMode === 'DEPOSIT_AND_BALANCE'
        ? (this.order_detail.isBalanceWaitingPayment ? this.balanceAmount : this.depositAmount) : (this.order_detail.totalAmount ? ('¥' + this.order_detail.totalAmount) : 0)
    },
    balancePaymentDetails () {
      return this.order_detail.balancePaymentDetails
    },
    // 是否显示尾款支付信息
    isShowBalancePaymentMessage () {
      return this.placementDetails.paymentMode === 'DEPOSIT_AND_BALANCE' && this.balancePaymentDetails &&
       (this.order_detail.orderStatus === 'COMPLETED' || this.order_detail.orderStatus === 'PAID')
    },
    has_USER_MANAGEMENT () {
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_USER_MANAGEMENT)
    },
    HAS_PERM_USER_READ_ONLY () {
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_USER_READ_ONLY)
    },
    user_url () {
      return this.has_USER_MANAGEMENT || this.HAS_PERM_USER_READ_ONLY
    }
  },
  methods: {
    showShipingMessage () {
      this.isShowShingMessage = !this.isShowShingMessage
    },
    closeOrder () {
      this.$emit('closeOrder')
    },
    tdWidth () {
      setTimeout(_ => {
        let width = this.$refs.td.getBoundingClientRect().width
        this.tdMaxWidth = width
        this.$emit('getTdMaxWidth', width)
      }, 300)
    }
  },
  created () {
    this.tdWidth()
  }
}
</script>
<style module lang="less">
@import "~less/var";
.get-customer-detail{
    justify-content: flex-start!important;
}
.order-message-content-all{
    padding:20px;
    :global
    .shiping-message-content{
        padding: 20px 0 0
    }
}
.order-message-content{
    padding-bottom:20px;
    border-bottom:solid 1px #BFC3CE
}
.payment-message-content,.order-message{
    display: flex;
    flex-direction: row;
    :global
    table{
        border: none;
        border-spacing:0;
        tr{
            td{
                line-height: 30px;
                font-size: 14px;
            }
            :first-child{
                display: flex;
                color:@mainColor;
                justify-content: flex-end;
                white-space:nowrap
            }
            .goods-order-status{
                color: @mainColor;
                font-size: 16px;
                font-weight: 600;
                div{
                    display: inline-block;
                    margin-left: 5px;
                    i{
                        color: #56575B
                    }
                }
            }
        }
    }
}
.order-message-basic{
    min-width: 50%
}
.goods-specifications{
    color: #000!important;
    justify-content: flex-start!important;
    :global
    span{
        color: #000!important;
    }
}
.show-amount-margin{
    td{
        padding-top: 20px
    }
}
.courier-number{
    color: #000!important;
    display: flex!important;
    justify-content: flex-start!important;
    :global
    .el-button{
        padding: 0;
        margin-left: 10px;
        line-height: 30px;
    }
}
.shipping-address-name{
    display: inline-block!important;
    color: #000!important;
    padding-right: 5px;
}
.payment-message-content{
    display: flex;
    justify-content: space-between;
    :global
.payment-message-content-item{
    display: flex;
    font-size: 14px;
    line-height: 30px;
    label{
        color:@mainColor;
        text-align:right
    }
}
.shiping-message-content{
     padding:20px;
     display: flex;
    flex-direction: row;
}
}
</style>
<style lang="less">
@import "~less/var";
</style>
